import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { colorPalette } from "../styles/theme";
import { useState, useRef, useEffect } from "react";
import { wsApi } from "../api/services";
import InquiryAnswer from "./InquiryAnswerView";

const InquiryDetailView = ({ inquiry, selectInquiry, setSelectInquiry, getInquiryList }) => {
  const [selectAnswer, setSelectAnswer] = useState(false)
  const answerAreaRef = useRef(null)
  const me = JSON.parse(localStorage.getItem("mallang_user"));
  const [answer,setAnswer] = useState([]);

  useEffect(() => {
    if (selectAnswer && answerAreaRef.current) {
      answerAreaRef.current.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }, [selectAnswer])

  const handlePatchStatus = async () => {
    await wsApi
      .patchInquiryStatus(inquiry.id)
      .then(() => {})
      .catch((err) => {
        // console.error("답변현황 변경 실패:", err);
      })
  
    getInquiryList();
    setSelectInquiry(false);
  }

  useEffect(() => {
    if (inquiry.status == "COMPLETE") {
      wsApi
        .getInquiryAnswer(inquiry.id)
        .then((res) => {
          setAnswer(res.data);
        })
        .catch((err) => {
          // console.error("답변글 불러오기 실패:", err);
        })
    }
  },[])

  return (
    <Paper sx={{ px: 10, py: 15, flex: 1, flexShrink: 0, overflowY: "scroll", scrollbarColor: "transparent transparent",}}>
      <Typography variant="h1" sx={{ pb: 3, fontWeight: 500, fontSize: 30, letterSpacing: "0.5px" }}>
        {inquiry.title}
      </Typography>
      <Box sx={{ display: "flex",gap: "10%", mb: 2 }}>
        {[
          { label: "문의 유형", value: inquiry.category },
          { label: "작성자", value: inquiry.user_name },
          { label: "등록일", value: inquiry.created_at.slice(0,10) },
        ].map(({ label, value }) => (
          <Box key={label} sx={{ display: "flex", gap: "20px", whiteSpace: "nowrap", minWidth: 160 }}>
            <Typography sx={{ fontWeight: "450" }}>{label}</Typography>
            <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>{value}</Typography>
          </Box>
        ))}
      </Box>
      <hr />
      <Typography sx={{ p: 1, minHeight: '400px', whiteSpace: "pre-wrap" }}>
        {inquiry.content}
      </Typography>

      {!selectAnswer && inquiry.status != "COMPLETE" ? 
      <Box sx={{ display: "flex", gap: "30px", justifyContent: "center", mt: 10 }}>
        <Button 
          sx={{ 
            backgroundColor: colorPalette.activeBg, 
            color: "#000000",
            width: 200,
            px: 4,
            py: 1.5,
            fontWeight: 450,
            "&:hover": {
              border: "1px solid #000000"
            }
          }}
          onClick={()=> setSelectAnswer(true)}
        >
          답변 남기기
        </Button>
        <Button 
          sx={{ 
            backgroundColor: colorPalette.activeBg, 
            color: "#000000",
            width: 200,
            px: 4,
            py: 1.5,
            fontWeight: 450,
            "&:hover": {
              border: "1px solid #000000"
            }
          }}
          onClick={()=> { handlePatchStatus(); }}  
        >
          목록
        </Button>
      </Box> : 
      !selectAnswer && inquiry.status == "COMPLETE" && answer.length != 0 ?
      <Box sx={{ mt: 40 }}>
        {/* 답변글 렌더링 */}
        <Typography variant="h1" sx={{ pb: 3, fontWeight: 500, fontSize: 30, letterSpacing: "0.5px" }}>
          {answer.title}
        </Typography>
        <Box sx={{ display: "flex",gap: "10%", mb: 2 }}>
          {[
            { label: "문의 유형", value: inquiry.category },
            { label: "관리자", value: me?.name },
            { label: "등록일", value: answer.created_at?.slice(0,10) },
          ].map(({ label, value }) => (
            <Box key={label} sx={{ display: "flex", gap: "20px", whiteSpace: "nowrap", minWidth: 160 }}>
              <Typography sx={{ fontWeight: "450" }}>{label}</Typography>
              <Typography sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>{value}</Typography>
            </Box>
          ))}
        </Box>
        <hr />
        <Typography sx={{ p: 1, minHeight: '400px', whiteSpace: "pre-wrap" }}>
          {answer.content}
        </Typography>
        <Button 
          sx={{ 
            backgroundColor: colorPalette.activeBg, 
            color: "#000000",
            width: 200,
            display: "block",
            mx: "auto", 
            my: 0,
            mt: 10,
            px: 4,
            py: 1.5,
            fontWeight: 450,
            "&:hover": {
              border: "1px solid #000000"
            },
          }}
          onClick={()=> { handlePatchStatus(); }}  
        >
          목록
        </Button>
      </Box> : null
      }

      {/* 답변글 작성 영역  */}
      {selectAnswer ? 
        // 스크롤 시 답변 작성 영역의 위쪽에 여백을 주기 위해 p,m으로 나눠서 스타일 지정
        <Box sx={{ pt: 10, mt: 20 }} ref={answerAreaRef}>
          <InquiryAnswer
            user_email={inquiry.email}
            inquiry_title={inquiry.title}
            inquiry_id={inquiry.id}
            selectInquiry={selectInquiry}
            setSelectInquiry={setSelectInquiry}
            handlePatchStatus={handlePatchStatus}
          />
        </Box> 
      : null}
    </Paper>
  )
}

export default InquiryDetailView;